<ng-container *ngIf="{ pending: pending$ | async, ready: ready$ | async } as status">
  <i *ngIf="status.pending" class="pi pi-spin pi-spinner reeval-pending"
     [title]="'translate.reeval.inProgress' | translate"></i>
  <i *ngIf="!status.pending && status.ready && allowRefresh" class="pi pi-refresh reeval-ready" role="button"
     [title]="'translate.reeval.readyToRefresh' | translate"
     (click)="onRefreshClick($event)"></i>
</ng-container>
